import React from 'react';
import { ListGroup } from 'react-bootstrap';

const AppSearchResults = ({ results, onAppSelect }) => {
    return (
        <ListGroup className="mt-3">
            {results.map((app) => (
                <ListGroup.Item
                    key={app.trackId}
                    action
                    onClick={() => onAppSelect(app)}
                    className="d-flex align-items-center mb-3"
                    style={{
                        borderRadius: '5px'
                    }}
                >
                    <img 
                        src={app.artworkUrl60} 
                        alt={app.trackName}
                        className="me-3"
                        style={{ width: '60px', height: '60px' }}
                    />
                    <div>
                        <h6 className="mb-1">{app.trackName}</h6>
                        <small className="text-muted">{app.artistName}</small>
                    </div>
                </ListGroup.Item>
            ))}
        </ListGroup>
    );
};

export default AppSearchResults; 